import { Component, OnDestroy, OnInit } from '@angular/core';
import { UploadFile } from '../../upload.service';
import { UploadStatusService } from '../service/status.service';

@Component({
  selector: 'app-upload-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.scss']
})
export class UploadStatusComponent implements OnInit, OnDestroy {

	uploadList: UploadFile[];

  constructor(
    private uploadStatusService: UploadStatusService,
  ) {
  }

  ngOnInit() {
    this.uploadList = this.uploadStatusService.uploadFiles;

    const that = this;
    this.uploadStatusService.listen().subscribe(() => {
      setTimeout(() => {
        that.doClose();
      }, 5000);
    });
  }

  ngOnDestroy() {
  }

  doClose() {
    this.uploadStatusService.close();
  }

}
